import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeadphonesSimple,
  faNavicon,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import NavContent from "./NavContent";
import axios from "axios";
import getSong from "../api/getSong";
import getSearchResults from "../api/getSearchResults";

export default function Topbar({
  setNavContent,
  navContent,
  darkMode,
  setDarkMode,
  songs,
  setCurrentSong,
  setIsLoading,
  setSongs,
  isPlaying,
  audioRef
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSongs, setFilteredSongs] = useState([]);
  const [isInputActive, setInputActive] = useState(false);
  const searchBarRef = useRef(null);

  // useEffect(() => {
  //   let debounceTimeout;
  //   const searchSongs = async () => {
  //     clearTimeout(debounceTimeout); 
  //     debounceTimeout = setTimeout(async () => {
  //       const searchResults = await getSearchResults(searchTerm);
  //       console.log(searchResults);
  //       setFilteredSongs(searchResults);
  //     }, 300); 
  //   };

  //   if (searchTerm !== '') {
  //     searchSongs();
  //   } else {
  //     setFilteredSongs("");
  //   }

  //   return () => {
  //     clearTimeout(debounceTimeout);
  //   };
  // }, [searchTerm]);
  useEffect(() => {
    const filterSongs = () => {
      const filtered = songs?.filter((song) =>
        song.title?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSongs(filtered);
    };
    filterSongs();
  }, [searchTerm, songs]);

  const handleSearchChange = (e) => {
    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);
  };
  const handleSongSelect = async (song) => {
    const selectedSong = await getSong(song.id);
    setCurrentSong(selectedSong);
    setIsLoading(false);
    setSearchTerm("");
    setInputActive(false);
    const newSongs = songs.map((item) => {
      if (item.id === song.id) {
        return { ...item, active: true };
      } else {
        return { ...item, active: false };
      }
    });
    await setSongs(newSongs);
    if (isPlaying) {
      audioRef.current.play();
    }
  }
 
  const toggleDark = () => {
    setDarkMode(!darkMode);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchBarRef.current && !searchBarRef.current.contains(e.target)) {
        setInputActive(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className="flex flex-col sm:flex-row sm:h-20 border-b border-[#FF8427] dark:bg-[#0d0f17] bg-[#fce168] text-[#0d0f17] dark:text-[#FFFFFF] sticky top-0 z-40 ">
      <NavContent navContent={navContent} setNavContent={setNavContent} />
      <div className="pl-5 h-20 w-full flex items-center justify-between sm:h-auto">
        <a
          href="App"
          className="cursor-pointer h-8 font-varela font-extrabold text-2xl "
        >
          <FontAwesomeIcon
            icon={faHeadphonesSimple}
            className="text-[#FF8427]"
          />
          MUSYK
        </a>
        <div className="Dark-mode items-center flex gap-x-2 fixed right-16">
          <span className="text-[#0d0f17] dark:text-[#FFFFFF]">
            {darkMode ? "Dark" : "Light"}
          </span>
          <label
            className="dark:bg-[#FFFFFF] bg-[#0d0f17] relative h-6 w-12 rounded-full cursor-pointer"
            htmlFor="dark"
          >
            <input
              type="checkbox"
              className="sr-only peer"
              name=""
              id="dark"
              checked={darkMode}
              onChange={() => {
                toggleDark();
                setDarkMode(!darkMode);
              }}
            />
            <span className="bg-[#FFFFFF] rounded-full h-[75%] w-[40%] absolute left-1 top-[0.20rem] peer-checked:bg-[#0d0f17]  peer-checked:left-[1.6rem] transition-all duration-300 "></span>
          </label>
        </div>
        <div className="items-center flex mr-5">
          <FontAwesomeIcon
            icon={faNavicon}
            className="text-2xl  cursor-pointer "
            onClick={() => {
              setNavContent(true);
            }}
          />
        </div>
      </div>
      <div className="w-full px-5 mx-auto mt-2 mb-4 sm:m-0 sm:absolute sm:left-1/2 sm:transform sm:-translate-x-1/2 sm:w-1/2 sm:h-full justify-center items-center block sm:flex" ref={searchBarRef}>
        <form className="relative w-full " onSubmit={handleSearchChange} >
          <input
            type="search"
            className="w-full text-[#0d0f17] max-w-full border border-[#191d242e] rounded-lg pr-4 pl-10 py-3 outline-none transition-colors duration-150 ease-in-out focus:border-[#FF8427]"
            placeholder="Search for songs..."
            value={searchTerm}
            onChange={handleSearchChange}
            onFocus={() => setInputActive(true)}
          />
          <FontAwesomeIcon
            icon={faSearch}
            className="absolute left-0 ml-4 top-1/2 transform -translate-y-1/2 text-gray-300"
          />
          {isInputActive && (
            <ul className="rounded-b-lg absolute bg-[#0d0f17c8] text-white px-2 py-6 h-[400px] overflow-scroll no-scrollbar w-full">
              {filteredSongs?.length > 0 ? (
                filteredSongs.map((song) => (
                  <li className="p-2 py-3 flex items-center gap-2 cursor-pointer border-[#2d334ee7] border-b-[1px]" key={song.id} onClick={() => handleSongSelect(song)}>
                    <img className="h-12 w-12 object-cover rounded-full" src={song.imageUrl} alt="cover" />
                    <p className="w-[80%] truncate">{song.title}</p>
                  </li>
                ))
              ) : (
                <li className="p-2">No results found.</li>
              )}
            </ul>
          )}
        </form>
      </div>
    </div>
  );
}
